import React from 'react';

{
	/*

Please insert the following into any new svg icon's main path to enable dynamic color change


className={`header-icons  ${props.className} ${props.variant}`}
style={{fill: props.fill?props.fill:''}}
fill={
	props.variant === 'filled'
	? '#fff'
	: ''
}

*/
}

interface Props {
	variant?: string;
	fill?: string;
	className?: string;
	color?: string;
	isModal?: boolean;
	width?: string;
	height?: string;
	filledColor?: string;
}

export function ThemedArrowRight(props: Props) {
	return (
		<svg
			data-name='arrow_forward_black_24dp (1)'
			xmlns='http://www.w3.org/2000/svg'
			width='16'
			height='16'
			viewBox='0 0 16 16'
			className={`header-icons  ${props.className} ${props.variant}`}
			style={{ fill: props.fill ? props.fill : '' }}
			fill={props.variant === 'filled' ? '#fff' : ''}
		>
			<path
				data-name='Path 2306'
				d='m9.333 4-.94.94 3.72 3.727H4V10h8.113l-3.72 3.727.94.94 5.333-5.333z'
				transform='translate(-1.333 -1.333)'
			/>
		</svg>
	);
}
export function ThemedPencil(props: Props) {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='24'
			height='24'
			viewBox='1 -2 24 24'
			className={`header-icons  ${props.className} ${props.variant}`}
			style={{ fill: props.fill ? props.fill : '' }}
			fill={props.variant === 'filled' ? '#fff' : ''}
		>
			<g data-name='pencil'>
				<path
					data-name='Path 2300'
					d='M3 17.25V21h3.75L17.81 9.94l-3.75-3.75zM20.71 7.04a1 1 0 0 0 0-1.41l-2.34-2.34a1 1 0 0 0-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z'
				/>
			</g>
		</svg>
	);
}

export function Language(props: Props) {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='100%'
			height='100%'
			viewBox='0 0 24 24'
		>
			<g data-name='Group 5391'>
				<path
					className={`header-icons  ${props.className} ${props.variant}`}
					style={{ fill: props.fill ? props.fill : '' }}
					fill={
						props.variant === 'filled' ? '#fff' : props.fill ? props.fill : ''
					}
					data-name='Path 2312'
					d='M11.99 2A10 10 0 1 0 22 12 10 10 0 0 0 11.99 2zm6.93 6h-2.95a15.649 15.649 0 0 0-1.38-3.56A8.03 8.03 0 0 1 18.92 8zM12 4.04A14.087 14.087 0 0 1 13.91 8h-3.82A14.087 14.087 0 0 1 12 4.04zM4.26 14a7.822 7.822 0 0 1 0-4h3.38a16.515 16.515 0 0 0-.14 2 16.515 16.515 0 0 0 .14 2zm.82 2h2.95a15.649 15.649 0 0 0 1.38 3.56A7.987 7.987 0 0 1 5.08 16zm2.95-8H5.08a7.987 7.987 0 0 1 4.33-3.56A15.649 15.649 0 0 0 8.03 8zM12 19.96A14.087 14.087 0 0 1 10.09 16h3.82A14.087 14.087 0 0 1 12 19.96zM14.34 14H9.66a14.713 14.713 0 0 1-.16-2 14.585 14.585 0 0 1 .16-2h4.68a14.585 14.585 0 0 1 .16 2 14.713 14.713 0 0 1-.16 2zm.25 5.56A15.649 15.649 0 0 0 15.97 16h2.95a8.03 8.03 0 0 1-4.33 3.56zM16.36 14a16.515 16.515 0 0 0 .14-2 16.515 16.515 0 0 0-.14-2h3.38a7.822 7.822 0 0 1 0 4z'
				/>
			</g>
		</svg>
	);
}

export function CheckedRadio(props: Props) {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='20'
			height='20'
			viewBox='0 -1 24 24'
		>
			<path
				className={`header-icons  ${props.className} ${props.variant}`}
				style={{ fill: props.fill ? props.fill : '' }}
				fill={
					props.variant === 'filled' ? '#fff' : props.fill ? props.fill : ''
				}
				data-name='Path 2388'
				d='M12 7a5 5 0 1 0 5 5 5 5 0 0 0-5-5zm0-5a10 10 0 1 0 10 10A10 10 0 0 0 12 2zm0 18a8 8 0 1 1 8-8 8 8 0 0 1-8 8z'
			/>
		</svg>
	);
}

export function UncheckedRadio(props: Props) {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='20'
			height='20'
			viewBox='0 -1 24 24'
		>
			<path
				className={`header-icons  ${props.className} ${props.variant}`}
				style={{ fill: props.fill ? props.fill : '' }}
				fill={
					props.variant === 'filled' ? '#fff' : props.fill ? props.fill : ''
				}
				data-name='Path 2388'
				d='M12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2zm0 18a8 8 0 1 1 8-8 8 8 0 0 1-8 8z'
			/>
		</svg>
	);
}
export function Logout(props: Props) {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='100%'
			height='100%'
			viewBox='0 0 24 24'
		>
			<g data-name='Group 5392'>
				<path
					className={`header-icons  ${props.className} ${props.variant}`}
					style={{ fill: props.fill ? props.fill : '' }}
					fill={
						props.variant === 'filled' ? '#fff' : props.fill ? props.fill : ''
					}
					data-name='Path 2283'
					d='m17 7-1.41 1.41L18.17 11H8v2h10.17l-2.58 2.58L17 17l5-5zM4 5h8V3H4a2.006 2.006 0 0 0-2 2v14a2.006 2.006 0 0 0 2 2h8v-2H4z'
				/>
			</g>
		</svg>
	);
}

export function Close(props: Props) {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='100%'
			height='100%'
			viewBox='0 0 24 24'
		>
			<g data-name='Group 5395'>
				<path
					className={`header-icons  ${props.className} ${props.variant}`}
					style={{ fill: props.fill ? props.fill : '' }}
					fill={
						props.variant === 'filled' ? '#fff' : props.fill ? props.fill : ''
					}
					data-name='Path 2288'
					d='M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z'
				/>
			</g>
		</svg>
	);
}

export function Ellipses(props: Props) {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='100%'
			height='100%'
			viewBox='0 0 24 24'
		>
			<path data-name='Path 2353' d='M0 0h24v24H0z' style={{ fill: 'none' }} />
			<path
				className={`header-icons  ${props.className} ${props.variant}`}
				style={{ fill: props.fill ? props.fill : '' }}
				fill={
					props.variant === 'filled' ? '#fff' : props.fill ? props.fill : ''
				}
				data-name='Path 2354'
				d='M12 8.001a2 2 0 1 0-2-2 2.006 2.006 0 0 0 2 2zm0 2a2 2 0 1 0 2 2 2.006 2.006 0 0 0-2-2zm0 6a2 2 0 1 0 2 2 2.006 2.006 0 0 0-2-2z'
			/>
		</svg>
	);
}

export function Back(props: Props) {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='100%'
			height='100%'
			viewBox='0 0 24 24'
		>
			<g data-name='Group 5401'>
				<path
					className={`header-icons  ${props.className} ${props.variant}`}
					style={{ fill: props.fill ? props.fill : '' }}
					fill={
						props.variant === 'filled' ? '#fff' : props.fill ? props.fill : ''
					}
					data-name='Path 2310'
					d='M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20z'
				/>
			</g>
		</svg>
	);
}

export function Minimise(props: Props) {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='100%'
			height='100%'
			viewBox='0 0 24 24'
		>
			<g data-name='Group 5394'>
				<path
					className={`header-icons  ${props.className} ${props.variant}`}
					style={{ fill: props.fill ? props.fill : '' }}
					fill={
						props.variant === 'filled' ? '#fff' : props.fill ? props.fill : ''
					}
					data-name='Path 2314'
					d='M22 3.41 16.71 8.7 20 12h-8V4l3.29 3.29L20.59 2zM3.41 22l5.29-5.29L12 20v-8H4l3.29 3.29L2 20.59z'
				/>
			</g>
		</svg>
	);
}

export function Maximise(props: Props) {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='100%'
			height='100%'
			viewBox='0 0 24 24'
		>
			<polygon
				className={`header-icons  ${props.className} ${props.variant}`}
				style={{ fill: props.fill ? props.fill : '' }}
				fill={
					props.variant === 'filled' ? '#fff' : props.fill ? props.fill : ''
				}
				points='21,11 21,3 13,3 16.29,6.29 6.29,16.29 3,13 3,21 11,21 7.71,17.71 17.71,7.71'
			/>
		</svg>
	);
}

export function Notification(props: Props) {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='100%'
			height='100%'
			viewBox='0 0 24 24'
		>
			<g data-name='Group 5393'>
				<path
					className={`header-icons  ${props.className} ${props.variant}`}
					style={{ fill: props.fill ? props.fill : '' }}
					fill={
						props.variant === 'filled' ? '#fff' : props.fill ? props.fill : ''
					}
					data-name='Path 2302'
					d='M12 22c1.1 0 2-.9 2-2h-4c0 1.1.9 2 2 2zm6-6v-5c0-3.07-1.63-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.64 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2zm-2 1H8v-6c0-2.48 1.51-4.5 4-4.5s4 2.02 4 4.5v6z'
				/>
			</g>
		</svg>
	);
}

export function NotificationFull(props: Props) {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='100%'
			height='100%'
			viewBox='0 0 24 24'
		>
			<g data-name='Group 5396' transform='translate(-20 -126)'>
				<path
					className={`header-icons  ${props.className} ${props.variant}`}
					style={{ fill: props.fill ? props.fill : '' }}
					fill={
						props.variant === 'filled' ? '#fff' : props.fill ? props.fill : ''
					}
					data-name='Subtraction 14'
					d='M32 148a2 2 0 0 1-2-2h4a2 2 0 0 1-2 2zm8-3H24v-1l2-2v-5a7.093 7.093 0 0 1 1.177-4.06 5.516 5.516 0 0 1 3.322-2.259V130a1.5 1.5 0 0 1 1.5-1.5 1.5 1.5 0 0 1 1.5 1.5v.681h.007c0 .13-.007.231-.007.319a5.474 5.474 0 0 0 .354 1.942A3.9 3.9 0 0 0 32 132.5a3.718 3.718 0 0 0-2.934 1.32 4.908 4.908 0 0 0-1.065 3.179v6h8v-6a5.536 5.536 0 0 0-.207-1.529 5.442 5.442 0 0 0 2.185.935c.014.2.021.4.021.594v5l2 2v1z'
				/>
				<circle
					className={`header-icons  ${props.className} ${props.variant}`}
					style={{ fill: props.fill ? props.fill : '' }}
					fill={
						props.variant === 'filled' ? '#fff' : props.fill ? props.fill : ''
					}
					data-name='Ellipse 520'
					cx='4'
					cy='4'
					r='4'
					transform='translate(35 127)'
				/>
			</g>
		</svg>
	);
}

export function Send(props: Props) {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='100%'
			height='100%'
			viewBox='0 0 24 24'
		>
			<path
				className={`header-icons  ${props.className} ${props.variant}`}
				style={{ fill: props.fill ? props.fill : '' }}
				fill={
					props.variant === 'filled' ? '#fff' : props.fill ? props.fill : ''
				}
				fillRule='evenodd'
				d='m2.00949,22l19.928,-10l-19.928,-10l-0.00949,7.77778l14.24107,2.22222l-14.24107,2.22222l0.00949,7.77778z'
			/>
		</svg>
	);
}

export function Mic(props: Props) {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='100%'
			height='100%'
			viewBox='0 0 24 24'
		>
			<path fill='none' d='M0 0h24v24H0z' />
			<path
				className={`header-icons  ${props.className} ${props.variant}`}
				style={{ fill: props.fill ? props.fill : '' }}
				fill={
					props.variant === 'filled' ? '#fff' : props.fill ? props.fill : ''
				}
				d='M12 14a2.987 2.987 0 0 0 2.99-3L15 5a3 3 0 0 0-6 0v6a3 3 0 0 0 3 3zm5.3-3a5.189 5.189 0 0 1-5.3 5.1A5.189 5.189 0 0 1 6.7 11H5a6.984 6.984 0 0 0 6 6.72V21h2v-3.28A6.968 6.968 0 0 0 19 11z'
			/>
		</svg>
	);
}

export function Accordian(props: Props) {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='100%'
			height='100%'
			viewBox='0 0 24 24'
		>
			<path data-name='Path 2344' d='M0 0h24v24H0z' style={{ fill: 'none' }} />
			<path
				className={`header-icons  ${props.className} ${props.variant}`}
				style={{ fill: props.fill ? props.fill : '' }}
				fill={
					props.variant === 'filled' ? '#fff' : props.fill ? props.fill : ''
				}
				data-name='Path 2345'
				d='M3 18h18v-2H3zm0-5h18v-2H3zm0-7v2h18V6z'
			/>
		</svg>
	);
}

export function Error(props: Props) {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='16'
			height='16'
			viewBox='0 0 16 16'
		>
			<path
				className={`header-icons  ${props.className} ${props.variant}`}
				style={{ fill: props.fill ? props.fill : '' }}
				fill={
					props.variant === 'filled' ? '#fff' : props.fill ? props.fill : ''
				}
				d='M8.667 2a6.667 6.667 0 1 0 6.667 6.667A6.669 6.669 0 0 0 8.667 2zm.667 10H8v-1.333h1.333zm0-2.667H8v-4h1.333z'
				transform='translate(-.667 -.666)'
				data-name='Error icon'
			/>
		</svg>
	);
}

export function Loader(props: Props) {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='24'
			height='24'
			viewBox='0 0 22 22'
			className={`header-icons ${props.className} ${props.variant}`}
		>
			<g data-name='Loader Round' style={{ opacity: 0.7 }}>
				<g data-name='Group 3939'>
					<g data-name='Group 3934'>
						<path
							// className={
							//   !props.isModal
							//     ? `header-icons  ${props.className} ${props.variant}`
							//     : ''
							// }
							style={{ fill: props.fill ? props.fill : '' }}
							fill={
								props.variant === 'filled'
									? '#fff'
									: props.fill
										? props.fill
										: ''
							}
							data-name='Subtraction 6'
							d='M9 18A9 9 0 1 1 9 0v2a7 7 0 1 0 7 7h2a9.01 9.01 0 0 1-9 9z'
							transform='translate(2.001 2)'
						/>
					</g>
				</g>
			</g>
		</svg>
	);
}

export function WifiOff(props: Props) {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='100%'
			height='100%'
			viewBox='0 0 20 20'
		>
			<path
				className={`header-icons  ${props.className} ${props.variant}`}
				style={{ fill: props.fill ? props.fill : '' }}
				fill={
					props.variant === 'filled' ? '#fff' : props.fill ? props.fill : ''
				}
				data-name='Path 2281'
				d='M19.325 7.8A12.943 12.943 0 0 0 7.533 4.282l2.1 2.1a10.545 10.545 0 0 1 8.025 3.083L19.325 7.8zm-3.333 3.333A8.161 8.161 0 0 0 12.25 9l2.942 2.942zM1.833 2.84l2.559 2.542A12.646 12.646 0 0 0 1 7.8l1.658 1.665a10.361 10.361 0 0 1 3.5-2.308l1.867 1.866a8.07 8.07 0 0 0-3.692 2.108v.008L5.992 12.8a5.869 5.869 0 0 1 4.1-1.717l5.892 5.883 1.058-1.05L2.908 1.79zm5.834 11.625 2.5 2.5 2.5-2.5a3.531 3.531 0 0 0-5 0z'
				transform='translate(-.167 -.298)'
			/>
		</svg>
	);
}

export function Info(props: Props) {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='100%'
			height='100%'
			viewBox='0 0 24 24'
		>
			<path
				className={`header-icons  ${props.className} ${props.variant}`}
				style={{ fill: props.fill ? props.fill : '' }}
				fill={
					props.variant === 'filled' ? '#fff' : props.fill ? props.fill : ''
				}
				data-name='Path 2281'
				d='M12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2zm1 15h-2v-6h2zm0-8h-2V7h2z'
			/>
		</svg>
	);
}

export function Diagnostics(props: Props) {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='100%'
			height='100%'
			viewBox='0 0 20 20'
		>
			<g
				id='Group_808'
				data-name='Group 808'
				transform='translate(1.442 1.442)'
			>
				<path
					className={`header-icons  ${props.className} ${props.variant}`}
					style={{ fill: props.fill ? props.fill : '' }}
					fill={
						props.variant === 'filled' ? '#fff' : props.fill ? props.fill : ''
					}
					id='Path_1357'
					data-name='Path 1357'
					d='M16.2 18.855H4.38A2.657 2.657 0 0 1 1.73 16.2V4.38a2.657 2.657 0 0 1 2.65-2.65H16.2a2.657 2.657 0 0 1 2.65 2.65V16.2a2.658 2.658 0 0 1-2.65 2.655zM4.38 2.972a1.4 1.4 0 0 0-1.4 1.4V16.2a1.4 1.4 0 0 0 1.4 1.4H16.2a1.4 1.4 0 0 0 1.4-1.4V4.38a1.4 1.4 0 0 0-1.4-1.4H4.38z'
					transform='translate(-1.73 -1.73)'
				/>
			</g>
			<g
				id='Group_809'
				data-name='Group 809'
				transform='translate(4.192 5.275)'
			>
				<path
					className={`header-icons  ${props.className} ${props.variant}`}
					style={{ fill: props.fill ? props.fill : '' }}
					fill={
						props.variant === 'filled' ? '#fff' : props.fill ? props.fill : ''
					}
					id='Path_1358'
					data-name='Path 1358'
					d='m11.7 14.913-2.208-5.3-.687 1.687H5.03v-1.25h2.933l1.509-3.72 2.228 5.333.688-1.663h4.2v1.25h-3.366z'
					transform='translate(-5.03 -6.33)'
				/>
			</g>
		</svg>
	);
}

export function Refresh(props: Props) {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='100%'
			height='100%'
			viewBox='0 0 20 20'
		>
			<path
				className={`header-icons  ${props.className} ${props.variant}`}
				style={{ fill: props.fill ? props.fill : '' }}
				fill={
					props.variant === 'filled' ? '#fff' : props.fill ? props.fill : ''
				}
				data-name='Path 2281'
				d='M15.377 5.958a6.668 6.668 0 1 0 1.733 6.375h-1.733a5 5 0 1 1-4.708-6.667 4.929 4.929 0 0 1 3.516 1.484L11.5 9.833h5.833V4z'
				transform='translate(-.668 -.667)'
			/>
		</svg>
	);
}

export function Share(props: Props) {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='100%'
			height='100%'
			viewBox='0 0 20 20'
		>
			<path
				className={`header-icons  ${props.className} ${props.variant}`}
				style={{ fill: props.fill ? props.fill : '' }}
				fill={
					props.variant === 'filled' ? '#fff' : props.fill ? props.fill : ''
				}
				data-name='Path 2281'
				d='M15.5 13.733a2.427 2.427 0 0 0-1.633.642l-5.942-3.458A2.728 2.728 0 0 0 8 10.333a2.728 2.728 0 0 0-.075-.583L13.8 6.325A2.494 2.494 0 1 0 13 4.5a2.728 2.728 0 0 0 .075.583L7.2 8.508a2.5 2.5 0 1 0 0 3.65l5.933 3.467a2.351 2.351 0 0 0-.067.542 2.433 2.433 0 1 0 2.434-2.434zm0-10.067a.833.833 0 1 1-.833.833.836.836 0 0 1 .833-.832zm-10 7.5a.833.833 0 1 1 .833-.833.836.836 0 0 1-.833.834zm10 5.85a.833.833 0 1 1 .833-.833.836.836 0 0 1-.833.834z'
				transform='translate(-.5 -.333)'
			/>
		</svg>
	);
}

export function ArrowLeft(props: Props) {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='100%'
			height='100%'
			viewBox='0 0 32 32'
		>
			<path
				className={`header-icons  ${props.className} ${props.variant}`}
				style={{ fill: props.fill ? props.fill : '' }}
				fill={
					props.variant === 'filled' ? '#fff' : props.fill ? props.fill : ''
				}
				data-name='Path 2281'
				d='M10.47 6 8.59 7.88 14.7 14l-6.11 6.12L10.47 22l8-8z'
				transform='rotate(180 14.568 15)'
			/>
		</svg>
	);
}

export function ArrowRight(props: Props) {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='100%'
			height='100%'
			viewBox='0 0 32 32'
		>
			<path
				className={`header-icons  ${props.className} ${props.variant}`}
				style={{ fill: props.fill ? props.fill : '' }}
				fill={
					props.variant === 'filled' ? '#fff' : props.fill ? props.fill : ''
				}
				data-name='Path 2281'
				d='M10.47 6 8.59 7.88 14.7 14l-6.11 6.12L10.47 22l8-8z'
				transform='translate(2.863 2)'
			/>
		</svg>
	);
}

export function CheckboxFilled(props: Props) {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='100%'
			height='100%'
			viewBox='0 0 20 20'
		>
			<path
				className={`header-icons  ${props.className} ${props.variant}`}
				style={{ fill: props.fill ? props.fill : '' }}
				fill={
					props.variant === 'filled' ? '#fff' : props.fill ? props.fill : ''
				}
				data-name='Path 2281'
				d='M16.333 3H4.667A1.666 1.666 0 0 0 3 4.667v11.666A1.666 1.666 0 0 0 4.667 18h11.666A1.666 1.666 0 0 0 18 16.333V4.667A1.666 1.666 0 0 0 16.333 3zm-7.5 11.667L4.667 10.5l1.175-1.175 2.992 2.983 6.325-6.325 1.175 1.183z'
				transform='translate(-0.5 -0.5)'
			/>
		</svg>
	);
}

export function CheckboxEmpty(props: Props) {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='100%'
			height='100%'
			viewBox='0 0 20 20'
		>
			<path
				className={`header-icons  ${props.className} ${props.variant}`}
				style={{ fill: props.fill ? props.fill : '' }}
				fill={
					props.variant === 'filled' ? '#fff' : props.fill ? props.fill : ''
				}
				data-name='Path 2281'
				d='M16.333 4.667v11.666H4.667V4.667h11.666m0-1.667H4.667A1.672 1.672 0 0 0 3 4.667v11.666A1.672 1.672 0 0 0 4.667 18h11.666A1.672 1.672 0 0 0 18 16.333V4.667A1.672 1.672 0 0 0 16.333 3z'
				transform='translate(-0.5 -0.5)'
			/>
		</svg>
	);
}

export function CloseBotArrow(props: Props) {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='40'
			height='40'
			viewBox='0 0 94 94'
		>
			<g id='minimise' transform='translate(-3319 -1595)'>
				<circle
					id='Ellipse_1222'
					data-name='Ellipse 1222'
					cx='47'
					cy='47'
					r='47'
					transform='translate(3319 1595)'
					fill='#2B8DED'
				/>
				<path
					id='Path_20432'
					data-name='Path 20432'
					d='M-8825.536-6588.574l18.194,16.74,19.39-16.74'
					transform='translate(12172 8224)'
					fill='none'
					stroke='#FFFFFF'
					stroke-linecap='round'
					stroke-width='3'
				/>
			</g>
		</svg>
	);
}

export function SendIconButton(props: Props) {
	return (
		<svg
			style={{ minWidth: '24px' }}
			xmlns='http://www.w3.org/2000/svg'
			width='24'
			height='24'
			viewBox='0 0 24 24'
		>
			<path data-name='Path 26' d='M0 0h24v24H0z' fill='none' />
			<path
				data-name='Path 27'
				d='M2.01 21 23 12 2.01 3 2 10l15 2-15 2z'
				fill={props.fill}
			/>
		</svg>
	);
}
export const WhiteTick = (props) => {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='13.06'
			height='10.531'
			viewBox='0 0 13.06 10.531'
		>
			<path
				id='Path_19875'
				data-name='Path 19875'
				d='M170.555,515.886l3.235,3.235,8.41-8.41'
				transform='translate(-169.848 -510.004)'
				fill='none'
				stroke='#fff'
				stroke-width='2'
			/>
		</svg>
	);
};
export function ForwardCarousel(props: Props) {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='32'
			height='32'
			viewBox='0 0 59 59'
			style={{ margin: '-5px 0px 0px -8px' }}
		>
			<g id='Fw-btn' transform='translate(0.089 0.089)'>
				<circle
					id='Ellipse_1221'
					data-name='Ellipse 1221'
					cx='29.5'
					cy='29.5'
					r='29.5'
					transform='translate(-0.089 -0.089)'
					fill={props.filledColor}
				/>

				<path
					id='Icon_ionic-ios-arrow-forward'
					data-name='Icon ionic-ios-arrow-forward'
					d='M23.114,21.048,11.87,9.812a2.114,2.114,0,0,1,0-3,2.141,2.141,0,0,1,3.008,0L27.617,19.544a2.12,2.12,0,0,1,.062,2.928L14.887,35.291a2.124,2.124,0,0,1-3.008-3Z'
					transform='translate(10.023 8.106)'
					fill={props.fill}
				/>
			</g>
		</svg>
	);
}
export function ForwardWelCarousel(props: Props) {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='32'
			height='32'
			viewBox='0 0 59 59'
			style={{
				margin: '-5px 0px 0px -8px',
				boxShadow: '0 4px 8px 0 rgba(0,0,0,0.28)',
				borderRadius: '50%',
			}}
		>
			<g id='Fw-btn' transform='translate(0.089 0.089)'>
				<circle
					id='Ellipse_1221'
					data-name='Ellipse 1221'
					cx='29.5'
					cy='29.5'
					r='29.5'
					transform='translate(-0.089 -0.089)'
					fill={props.filledColor}
				/>

				<path
					id='Icon_ionic-ios-arrow-forward'
					data-name='Icon ionic-ios-arrow-forward'
					d='M23.114,21.048,11.87,9.812a2.114,2.114,0,0,1,0-3,2.141,2.141,0,0,1,3.008,0L27.617,19.544a2.12,2.12,0,0,1,.062,2.928L14.887,35.291a2.124,2.124,0,0,1-3.008-3Z'
					transform='translate(10.023 8.106)'
					fill={props.fill}
				/>
			</g>
		</svg>
	);
}
export function BackwardCarousel(props: Props) {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='32'
			height='32'
			viewBox='0 0 59 59'
			style={{ margin: '-5px 0px 0px -8px' }}
		>
			<g id='Fw-btn' transform='translate(0 0)'>
				<circle
					id='Ellipse_1221'
					data-name='Ellipse 1221'
					cx='29.5'
					cy='29.5'
					r='29.5'
					transform='translate(0 0)'
					fill={props.filledColor}
				/>

				<path
					id='Icon_ionic-ios-arrow-forward'
					data-name='Icon ionic-ios-arrow-forward'
					d='M16.368,21.048,27.612,9.812a2.114,2.114,0,0,0,0-3,2.141,2.141,0,0,0-3.008,0L11.865,19.544a2.12,2.12,0,0,0-.062,2.928L24.6,35.291a2.124,2.124,0,0,0,3.008-3Z'
					transform='translate(9.405 8.195)'
					fill={props.fill}
				/>
			</g>
		</svg>
	);
}
export function BackwardWelCarousel(props: Props) {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width={props.width ? props.width : '32'}
			height={props.height ? props.height : '32'}
			viewBox='0 0 59 59'
			style={{
				margin: '-5px 0px 0px -8px',
				boxShadow: '0 4px 8px 0 rgba(0,0,0,0.28)',
				borderRadius: '50%',
			}}
		>
			<g id='Fw-btn' transform='translate(0 0)'>
				<circle
					id='Ellipse_1221'
					data-name='Ellipse 1221'
					cx='29.5'
					cy='29.5'
					r='29.5'
					transform='translate(0 0)'
					fill={props.filledColor}
				/>

				<path
					id='Icon_ionic-ios-arrow-forward'
					data-name='Icon ionic-ios-arrow-forward'
					d='M16.368,21.048,27.612,9.812a2.114,2.114,0,0,0,0-3,2.141,2.141,0,0,0-3.008,0L11.865,19.544a2.12,2.12,0,0,0-.062,2.928L24.6,35.291a2.124,2.124,0,0,0,3.008-3Z'
					transform='translate(9.405 8.195)'
					fill={props.fill}
				/>
			</g>
		</svg>
	);
}

export function UploadImage(props: Props) {
	return (
		<svg
			width={24}
			height={24}
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<mask
				id="a"
				style={{
					maskType: "alpha",
				}}
				maskUnits="userSpaceOnUse"
				x={0}
				y={0}
				width={24}
				height={24}
			>
				<path fill="#D9D9D9" d="M0 0h24v24H0z" />
			</mask>
			<g mask="url(#a)">
				<path
					d="M5.308 20.5c-.505 0-.933-.175-1.283-.525a1.745 1.745 0 0 1-.525-1.283V5.308c0-.505.175-.933.525-1.283.35-.35.778-.525 1.283-.525h13.384c.505 0 .933.175 1.283.525.35.35.525.778.525 1.283v13.384c0 .505-.175.933-.525 1.283-.35.35-.778.525-1.283.525H5.308Zm0-1.5h13.384a.294.294 0 0 0 .212-.096.294.294 0 0 0 .096-.212V5.308a.294.294 0 0 0-.096-.212.294.294 0 0 0-.212-.096H5.308a.294.294 0 0 0-.212.096.294.294 0 0 0-.096.212v13.384c0 .077.032.148.096.212a.294.294 0 0 0 .212.096Zm2.346-2.25h8.769c.18 0 .315-.082.402-.246a.416.416 0 0 0-.04-.477L14.4 12.833a.438.438 0 0 0-.361-.181.437.437 0 0 0-.362.18l-2.446 3.187-1.639-2.1a.441.441 0 0 0-.357-.171.433.433 0 0 0-.356.181l-1.577 2.098c-.12.154-.137.313-.05.477a.428.428 0 0 0 .402.246Z"
					fill="#000"
				/>
			</g>
		</svg>
	)

}

export function MicIcon(props: Props) {
	return (
		<svg
			width={24}
			height={24}
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<mask
				id="a"
				style={{
					maskType: "alpha",
				}}
				maskUnits="userSpaceOnUse"
				x={0}
				y={0}
				width={24}
				height={24}
			>
				<path fill="#D9D9D9" d="M0 0h24v24H0z" />
			</mask>
			<g mask="url(#a)">
				<path
					d="M12 13.5c-.699 0-1.29-.242-1.774-.726A2.413 2.413 0 0 1 9.5 11V5c0-.699.242-1.29.726-1.774A2.413 2.413 0 0 1 12 2.5c.698 0 1.29.242 1.774.726S14.5 4.301 14.5 5v6c0 .699-.242 1.29-.726 1.774A2.413 2.413 0 0 1 12 13.5Zm-.75 6.5v-2.546a6.33 6.33 0 0 1-3.827-1.835c-1.063-1.051-1.685-2.332-1.868-3.844a.653.653 0 0 1 .168-.547A.682.682 0 0 1 6.25 11c.212 0 .39.073.534.22.144.147.24.327.287.54a4.8 4.8 0 0 0 1.68 3.038A4.854 4.854 0 0 0 12 16c1.245 0 2.332-.405 3.261-1.214.93-.81 1.485-1.819 1.667-3.027.048-.212.143-.392.287-.539a.717.717 0 0 1 .535-.22c.212 0 .388.076.527.228a.653.653 0 0 1 .167.547 6.394 6.394 0 0 1-1.855 3.814c-1.054 1.065-2.334 1.687-3.84 1.865V20a.725.725 0 0 1-.215.535.725.725 0 0 1-.534.215.725.725 0 0 1-.535-.215.726.726 0 0 1-.215-.535Zm.75-8c.283 0 .52-.096.712-.287A.968.968 0 0 0 13 11V5a.967.967 0 0 0-.288-.713A.967.967 0 0 0 12 4a.968.968 0 0 0-.713.287A.968.968 0 0 0 11 5v6c0 .283.095.52.287.713.192.191.43.287.713.287Z"
					fill="#000"
				/>
			</g>
		</svg>
	)
}